import { css } from '@emotion/css'
import colors from '@styles/colors';

export default {
    container: css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        flexWrap: 'wrap',
        color: colors.WHITE,

        'img': {
            maxWidth: '100%',
            maxHeight: '100%',
        },

        '> div[class^="ing-"]': {
            width: 40,
            height: 40,
            margin: '0 5px',
            display: 'flex',
            textAlign: 'center',
            WebkitBoxAlign: 'center',
            MsFlexAlign: 'center',
            alignItems: 'center',
            WebkitBoxPack: 'center',
            MsFlexPack: 'center',
            justifyContent: 'center',
            position: 'relative',
        },
    }),
};
